import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Joint = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 640 512"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M448 32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 55.2 21.9 108.1 60.9 147.1l21 21c9 9 14.1 21.2 14.1 33.9v11c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-29.7-11.8-58.2-32.8-79.2l-21-21c-27-27-42.2-63.6-42.2-101.8V32zm128 224c0 17.7 14.3 32 32 32s32-14.3 32-32v-11c0-55.2-21.9-108.1-60.9-147.1l-21-21c-9-9-14.1-21.2-14.1-33.9V32c0-17.7-14.3-32-32-32s-32 14.3-32 32v11c0 29.7 11.8 58.2 32.8 79.2l21 21c27 27 42.2 63.6 42.2 101.8v11zM229.8 360c-4.7-2.3-10-2.7-15.2-2-37.8 5.6-75.2 14.3-106.9 22.8-26.4 7.2-49.4 14.3-65.7 19.6-8.2 2.7-14.7 4.9-19.2 6.5-2.3.8-4 1.4-5.2 1.8l-1.3.5C6.8 412.5 0 421.4 0 432s6.8 19.5 16.3 22.7l1.3.5c1.2.4 3 1.1 5.2 1.8 4.5 1.6 11 3.8 19.2 6.5 16.3 5.4 39.2 12.5 65.7 19.6C160.3 497.3 228.8 512 288 512h67.3c4.1 0 6.3-5.1 3.6-8.3L256.5 380.8c-7.4-8.9-16.5-15.9-26.7-20.8zM445 512h70.3c4.1 0 6.3-5.1 3.6-8.3L416.5 380.8C401.3 362.5 378.8 352 355 352h-70.4c-4.1 0-6.2 5.1-3.5 8.3l102.4 122.9c15.2 18.3 37.7 28.8 61.5 28.8zm-3.9-151.7 102.4 122.9c14.6 17.5 35.9 27.9 58.6 28.7 21.1-1.1 37.9-18.6 37.9-39.9v-80c0-22.1-17.9-40-40-40H444.7c-4.1 0-6.3 5.1-3.6 8.3z"
  }));
});
Joint.displayName = 'Joint';
export var JointDimensions = {
  height: 512,
  width: 640
};